export default __webpack_public_path__ + "static/media/image-mascot.c07a6473.png";